import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// react-snap prerenders each route to static HTML at build time for
// crawlers/SEO. On load we client-render over it (plain render, not hydrate)
// because the snapshot captures post-animation inline styles, which would
// otherwise cause hydration mismatch noise for zero visitor benefit.
ReactDOM.createRoot(document.getElementById("root")).render(app);
